var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHybrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17s6-4.308 6-9.846a6.234 6.234 0 00-1.757-4.352A5.925 5.925 0 009 1a5.925 5.925 0 00-4.243 1.802A6.235 6.235 0 003 7.154C3 12.692 9 17 9 17zm.688-13.625L8.25 4.814A4.63 4.63 0 019.697 8.17a4.632 4.632 0 01-1.475 3.384l1.439 1.44a6.66 6.66 0 002.07-4.824 6.658 6.658 0 00-2.043-4.796zM5.812 7.251a1.396 1.396 0 01.14 2.035l1.223 1.222a3.295 3.295 0 00.932-2.302c0-.898-.359-1.713-.94-2.31L5.812 7.252z",
    fill: "currentColor"
  })));
}
export default SvgHybrid;